"use strict";

const mix = require('./mix');
const FiltersHash = require('../filters-hash');


/**
 * Mixin methods which allow to add FiltersHash into ConfigurePane
 *
 * @param superclass
 * @returns {{}}
 * @constructor
 */
function FiltersHashPaneMixin(superclass) {
	return class extends superclass {
		initFiltersHash(options) {
			options = Object.assign({}, options);
			this.addComponent('filters', new FiltersHash(options));
		}

		get filtersHash() {
			return this.getComponent('filters');
		}
	}
}

mix.MIXINS.set('FILTERS', FiltersHashPaneMixin);
exports.mixin = FiltersHashPaneMixin;